export default __webpack_public_path__ + "static/media/check-mark.b343a46f.png";